import { useEffect, useState } from 'react'

import {
  APP_CDT_OPEN_TIMEOUT_MS,
  APP_CDT_REDIRECT_STORAGE_PREFIX,
  buildAppCdtDeepLink,
  isMobileDevice,
} from '@/modules/checkout/utils/appDeepLink'
import { PaymentFlowAnalytics } from '@/shared/utils/analytics'

const storageKey = (id: string) => `${APP_CDT_REDIRECT_STORAGE_PREFIX}:${id}`

const hasAlreadyTried = (id: string) => {
  try {
    return window.sessionStorage.getItem(storageKey(id)) === 'true'
  } catch {
    return false
  }
}

const markAsTried = (id: string) => {
  try {
    window.sessionStorage.setItem(storageKey(id), 'true')
  } catch {
    // sessionStorage indisponível (navegação privada ou webview restrita):
    // segue sem o guard, o pior caso é uma nova tentativa ao recarregar
  }
}

const openAppCdt = (id: string) => {
  window.location.href = buildAppCdtDeepLink(id)
}

export const useRedirectToAppCdt = (id: string, isEnabled: boolean) => {
  const [isOpeningApp, setIsOpeningApp] = useState(false)

  useEffect(() => {
    if (!id || !isEnabled || !isMobileDevice() || hasAlreadyTried(id)) {
      return
    }

    markAsTried(id)
    setIsOpeningApp(true)

    let hasLeftThePage = false

    const handleVisibilityChange = () => {
      if (document.hidden) {
        hasLeftThePage = true
        return
      }

      if (hasLeftThePage) {
        setIsOpeningApp(false)
      }
    }

    const handlePageHide = () => {
      hasLeftThePage = true
    }

    document.addEventListener('visibilitychange', handleVisibilityChange)
    window.addEventListener('pagehide', handlePageHide)

    PaymentFlowAnalytics.onAppRedirectAttempt()
    openAppCdt(id)

    const timeoutId = window.setTimeout(() => {
      if (hasLeftThePage || document.hidden) {
        return
      }

      PaymentFlowAnalytics.onAppRedirectFallback()
      setIsOpeningApp(false)
    }, APP_CDT_OPEN_TIMEOUT_MS)

    return () => {
      window.clearTimeout(timeoutId)
      document.removeEventListener('visibilitychange', handleVisibilityChange)
      window.removeEventListener('pagehide', handlePageHide)
    }
  }, [id, isEnabled])

  return {
    isOpeningApp,
  }
}
